<template>
  <b-card class="sa-card sa-card-scroll" header="" header-tag="header" footer-tag="footer" title="">
    <b-row>
      <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
        <label class="sa-label-data">Struttura: </label>
        <b-form-select v-model="jsonData.codiceAzienda" :options="strutturaOptions" :value="''">
          <template #first>
            <b-form-select-option :value="null" disabled> - Seleziona Struttura - </b-form-select-option>
          </template>
        </b-form-select>
      </b-col>

      <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
        <label class="sa-label-data">Tipo:</label>
        <b-form-select v-model="jsonData.codiceTipoArticolo" :options="tipoArticoloOptions" :value="''"
          value-field="codiceTipoArticolo" text-field="descrizioneTipoArticolo">
          <template #first>
            <b-form-select-option :value="null" disabled> - Seleziona Tipo Articolo - </b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
      <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
        <label class="sa-label-data">Codice AIC:</label>
        <b-input-group class="mb-3">
          <b-form-input v-model="jsonData.codiceAic" :readonly="isFarmaco"></b-form-input>
          <b-button size="sm" variant="secondary" @click="onClickSearchCodiceAic" :disabled="!isFarmaco">
            <b-icon icon="search"> </b-icon>
          </b-button>
        </b-input-group>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
        <label class="sa-label-data">Nome:</label>
        <b-form-input v-model="jsonData.nomeArticolo"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
        <label class="sa-label-data">Codice Interno:</label>
        <b-form-input v-model="jsonData.codiceArticolo"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
        <label class="sa-label-data">Codice Barre:</label>
        <b-form-input v-model="jsonData.codiceBarre" :readonly="isFarmaco"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <label class="sa-label-data">Descrizione:</label>
        <b-form-textarea v-model="jsonData.descrizioneArticolo" rows="7" max-rows="10"></b-form-textarea>
      </b-col>

      <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
        <label class="sa-label-data">Unità di Misura:</label>
        <b-input-group>
          <b-form-select v-model="jsonData.umId" :options="umOptions" :value="null" text-field="descrizioneMultiplo"
            value-field="id" @change="onUmArticoloSetDescrizioneMultiplo">
            <template #first>
              <b-form-select-option :value="null" disabled> - Seleziona U. M. - </b-form-select-option>
            </template>
          </b-form-select>
          <b-button size="sm" variant="secondary" @click="onClickNuovaUM">
            <b-icon icon="plus"> </b-icon>
          </b-button>
        </b-input-group>
      </b-col>
      <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
        <label class="sa-label-data">Unità di Misura Base:</label>
        <b-input-group>
          <b-form-select v-model="jsonData.umBaseId" :options="umOptions" :value="null" text-field="descrizioneMultiplo"
            value-field="id" @change="onUmArticoloSetDescrizioneMultiplo">
            <template #first>
              <b-form-select-option :value="null" disabled> - Seleziona U. M. - </b-form-select-option>
            </template>
          </b-form-select>
          <b-button size="sm" variant="secondary" @click="onClickNuovaUM">
            <b-icon icon="plus"> </b-icon>
          </b-button>
        </b-input-group>
      </b-col>
      <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
        <label class="sa-label-data">Categoria:</label>
        <b-input-group>
          <b-form-select v-model="jsonData.categoria" :options="categorieOptions" :value="''">
            <template #first>
              <b-form-select-option :value="null" disabled> - Seleziona Categoria - </b-form-select-option>
            </template>
          </b-form-select>
          <b-button size="sm" variant="secondary" @click="onClickNuovaCategoria">
            <b-icon icon="plus"> </b-icon>
          </b-button>
        </b-input-group>
      </b-col>
      <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
        <label class="sa-label-data">Marca:</label>
        <b-input-group>
          <b-form-select v-model="jsonData.marca" :options="marcheOptions" :value="''">
            <template #first>
              <b-form-select-option :value="null" disabled> - Seleziona Marca - </b-form-select-option>
            </template>
          </b-form-select>
          <b-button size="sm" variant="secondary" @click="onClickNuovaMarca">
            <b-icon icon="plus"> </b-icon>
          </b-button>
        </b-input-group>
      </b-col>
      <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
        <label class="sa-label-data">Imballo:</label>
        <b-input-group>
          <b-form-select v-model="jsonData.descrizioneImballo" :options="imballoOptions" :value="''">
            <template #first>
              <b-form-select-option :value="null" disabled> - Seleziona Imballo - </b-form-select-option>
            </template>
          </b-form-select>
          <b-button size="sm" variant="secondary" @click="onClickNuovaImballo">
            <b-icon icon="plus"> </b-icon>
          </b-button>
        </b-input-group>
      </b-col>
      <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
        <label class="sa-label-data">Iva:</label>
        <b-form-select v-model="jsonData.codiceIva" :options="contabilitaIvaOptions" text-field="descrizioneIva"
          value-field="codiceIva">
          <template #first>
            <b-form-select-option :value="null" disabled> - Seleziona I.V.A. - </b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
      <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
        <label class="sa-label-data">Lotti e Scadenze:</label>
        <b-checkbox v-model="gestioneLottiScadenzeComputed" switch></b-checkbox>
      </b-col>
      <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
        <label class="sa-label-data">Matricole:</label>
        <b-checkbox v-model="gestioneMatricoleComputed" switch></b-checkbox>
      </b-col>
      <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
        <label class="sa-label-data">Ultimo Prez. Acq.:</label>
        <b-form-input v-model="jsonData.ultimoPrezzoAcquisto" type="number"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
        <label class="sa-label-data">Prezzo Med. Acq.:</label>
        <b-form-input v-model="jsonData.prezzoMedioAcquisto" type="number"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
        <label class="sa-label-data">Sconto:</label>
        <b-form-input v-model="jsonData.scontoArticolo" type="number"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
        <label class="sa-label-data">Sottoscorta:</label>
        <b-form-input v-model="jsonData.sottoscortaArticolo" type="number"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
        <label class="sa-label-data">Prezzo Acq. Stand.:</label>
        <b-form-input v-model="jsonData.prezzoAcquistoStandard" type="number"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
        <label class="sa-label-data">Colli:</label>
        <b-form-input v-model="jsonData.colliArticolo" type="number"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
        <label class="sa-label-data">Peso(kg)</label>
        <b-form-input v-model="jsonData.pesoArticolo" type="number"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
        <label class="sa-label-data">Lunghezza(cm)</label>
        <b-form-input v-model="jsonData.lunghezzaArticolo" type="number"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
        <label class="sa-label-data">Altezza(cm)</label>
        <b-form-input v-model="jsonData.altezzaArticolo" type="number"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
        <label class="sa-label-data">Larghezza(cm)</label>
        <b-form-input v-model="jsonData.larghezzaArticolo" type="number"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <label class="sa-label-data">Note:</label>
        <b-form-textarea v-model="jsonData.noteArticolo" rows="7" max-rows="10"></b-form-textarea>
      </b-col>
    </b-row>

    <codice-aic-modal-list-component ref="mdlCodiceAicList" @update="onUpdate" />
    <modal-error ref="cmpModalError"></modal-error>
    <configurazioni-magazzino-articoli-um-modal-edit-component ref="cmpConfigurazioniMagazzinoArticoliUmModalEdit"
      v-if="showModalUM" :jsonData="jsonData" @saveUmArticolo="onSaveUmArticolo" />
    <configurazioni-magazzino-articoli-categoria-modal-edit-component
      ref="cmpConfigurazioniMagazzinoArticoliCategoriaModalEdit" v-if="showModalCategoria" :jsonData="jsonData"
      @saveCategoriaArticolo="onSaveCategoriaArticolo" />
    <configurazioni-magazzino-articoli-marca-modal-edit-component ref="cmpConfigurazioniMagazzinoArticoliMarcaModalEdit"
      v-if="showModalMarca" :jsonData="jsonData" @saveMarcaArticolo="onSaveMarcaArticolo" />
    <!-- <configurazioni-magazzino-articoli-multiplo-modal-edit-component ref="cmpConfigurazioniMagazzinoArticoliMultiploModalEdit" v-if="showModalMultiplo" @saveMultiploArticolo="onSaveMultiploArticolo" /> -->
    <configurazioni-magazzino-articoli-imballo-modal-edit-component
      ref="cmpConfigurazioniMagazzinoArticoliImballoModalEdit" v-if="showModalImballo" :jsonData="jsonData"
      @saveImballoArticolo="onSaveImballoArticolo" />
  </b-card>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import CodiceAicModalListComponent from "./CodiceAicModalListComponent.vue";
import ConfigurazioniMagazzinoArticoliUmModalEditComponent from "./ConfigurazioniMagazzinoArticoliUmModalEditComponent.vue";
import ConfigurazioniMagazzinoArticoliCategoriaModalEditComponent from "./ConfigurazioniMagazzinoArticoliCategoriaModalEditComponent.vue";
import ConfigurazioniMagazzinoArticoliMarcaModalEditComponent from "./ConfigurazioniMagazzinoArticoliMarcaModalEditComponent.vue";
import ConfigurazioniMagazzinoArticoliImballoModalEditComponent from "./ConfigurazioniMagazzinoArticoliImballoModalEditComponent.vue";
import ContabilitaMixin from "../../contabilita/mixins/ContabilitaMixin";
export default {
  name: "MagazzinoArticoliAnagraficaEditComponent",
  mixins: [UtilityMixin, ContabilitaMixin],
  components: {
    ModalError,
    CodiceAicModalListComponent,
    ConfigurazioniMagazzinoArticoliUmModalEditComponent,
    ConfigurazioniMagazzinoArticoliCategoriaModalEditComponent,
    ConfigurazioniMagazzinoArticoliMarcaModalEditComponent,
    ConfigurazioniMagazzinoArticoliImballoModalEditComponent,
  },
  data() {
    return {
      id: "-1",
      presidio: {},
      pathResourceTipiArticolo: "/magazzinoarticolitipo",
      pathResourceUmArticolo: "/magazzinoarticolium",
      pathResourceCategoriaArticolo: "/magazzinoarticolicategorie",
      pathResourceMarcheArticolo: "/magazzinoarticolimarche",
      pathResourceImballoArticolo: "/magazzinoarticoliimballi",
      pathResourceMagazzinoArticolo: "/magazzinoarticoli",
      pathResourceStrutture: "/strutture",
      tipoArticoloOptions: [],
      umOptions: [],
      categorieOptions: [],
      marcheOptions: [],
      multiploOptions: [],
      imballoOptions: [],
      codiceIvaOptions: [],
      strutturaOptions: [],
      isFarmaco: false,
      showModalUM: false,
      showModalCategoria: false,
      showModalMarca: false,
      showModalImballo: false,
      showModalMultiplo: false,

      jsonData: {
        id: null,
        codiceTipoArticolo: null,
        codiceArticolo: null,
        codiceBarre: null,
        nomeArticolo: null,
        descrizioneArticolo: null,
        codiceAzienda: null,
        categoria: null,
        marca: null,
        descrizioneMultiplo: null,
        descrizioneImballo: null,
        codiceIva: null,
        gestioneLottiScadenze: null,
        gestioneMatricole: null,
        ultimoPrezzoAcquisto: null,
        prezzoMedioAcquisto: null,
        scontoArticolo: null,
        sottoscortaArticolo: null,
        prezzoAcquistoStandard: null,
        colliArticolo: null,
        pesoArticolo: null,
        lunghezzaArticolo: null,
        altezzaArticolo: null,
        larghezzaArticolo: null,
        noteArticolo: null,
        giacenze: null,
        codiceAic: null,
      },
    };
  },
  computed: {
    gestioneLottiScadenzeComputed: {
      get() {
        return this.jsonData.gestioneLottiScadenze;
      },
      set(value) {
        this.jsonData.gestioneLottiScadenze = value;
        if (value) {
          this.jsonData.gestioneMatricole = false;
        }
      },
    },
    gestioneMatricoleComputed: {
      get() {
        return this.jsonData.gestioneMatricole;
      },
      set(value) {
        this.jsonData.gestioneMatricole = value;
        if (value) {
          this.jsonData.gestioneLottiScadenze = false;
        }
      },
    },
  },
  mounted() {
    let me = this;
    me.id = this.$route.params.id;
    me.loadDataTipoArticolo();
    me.loadDataUmArticolo();
    me.loadDataCategoriaArticolo();
    me.loadDataMarcaArticolo();
    me.loadDataImballoArticolo();
    me.loadDataStrutture();
    me.contabilitaTabellaIvaLoadData();
    me.setDatiStruttura();
    if (me.id != -1) {
      me.loadDataArticoloMagazzino(me.id);
    } else {
      this.setStruttura();
    }
  },
  watch: {
    "jsonData.codiceTipoArticolo"(newValue) {
      let me = this;
      me.isFarmaco = newValue === "FRM"; //Controllo booleano
      me.$emit("tipoArticolo", me.isFarmaco);
    },
    jsonData: {
      handler(newValue) {
        if (newValue) {
          this.$emit("updateJsonData", newValue);
        }
      },
      deep: true,
    },
  },
  methods: {
    getJsonData() {
      return this.jsonData;
    },

    onUmArticoloSetDescrizioneMultiplo(value) {
      let result = null;
      for (let a of this.umOptions) {
        if (a.id == value) {
          result = a;
          break;
        }
      }
      if (result) {
        this.jsonData.descrizioneMultiplo = result.descrizioneMultiplo;
      }
    },
    setStruttura() {
      this.jsonData.codiceAzienda = this.presidio.codiceStruttura;

    },
    setDatiStruttura() {
      let tmpPresidio = window.localStorage.getItem("presidio");
      //console.log(tmpPresidio);

      if (tmpPresidio) {
        this.presidio = JSON.parse(tmpPresidio);
      }
    },

    loadDataArticoloMagazzino(id) {
      let me = this;
      me.$emit("beforeLoadData");
      UtilityMixin.methods.loadDataResources(me.pathResourceMagazzinoArticolo + "/" + id, null, me.loadDataArticoloMagazzinoSuccess, me.loadDataArticoloMagazzinoError);
    },
    loadDataArticoloMagazzinoSuccess(response) {
      let me = this;
      me.$emit("afterLoadData");
      me.jsonData = response.data.data;
      me.$emit("updateJsonData", me.jsonData);
      /* me.$nextTick(() => {
                me.controlEmit = true;

            }); */
    },
    loadDataArticoloMagazzinoError(response) {
      let me = this;
      me.$emit("afterLoadData");
      console.log(response);
    },
    loadDataTipoArticolo() {
      let me = this;
      UtilityMixin.methods.loadDataResources(me.pathResourceTipiArticolo, {}, me.loadDataTipoArticoloSuccess, me.loadDataTipoArticoloError);
    },
    loadDataTipoArticoloSuccess(response) {
      let me = this;
      me.tipoArticoloOptions = response.data.data.list;
    },
    loadDataTipoArticoloError(error) {
      console.log(error);
    },
    loadDataUmArticolo() {
      let me = this;
      UtilityMixin.methods.loadDataResources(me.pathResourceUmArticolo, {}, me.loadDataUmArticoloSuccess, me.loadDataUmArticoloError);
    },
    loadDataUmArticoloSuccess(response) {
      let me = this;
      me.umOptions = response.data.data.list;
    },
    loadDataUmArticoloError(error) {
      console.log(error);
    },
    loadDataCategoriaArticolo() {
      let me = this;
      UtilityMixin.methods.loadDataResources(me.pathResourceCategoriaArticolo, {}, me.loadDataCategoriaArticoloSuccess, me.loadDataCategoriaArticoloError);
    },
    loadDataCategoriaArticoloSuccess(response) {
      let me = this;
      me.categorieOptions = response.data.data.list.map((item) => ({
        value: item.categoria,
        text: item.categoria,
      }));
    },
    loadDataCategoriaArticoloError(error) {
      console.log(error);
    },
    loadDataMarcaArticolo() {
      let me = this;
      UtilityMixin.methods.loadDataResources(me.pathResourceMarcheArticolo, {}, me.loadDataMarcaArticoloSuccess, me.loadDataMarcaArticoloError);
    },
    loadDataMarcaArticoloSuccess(response) {
      let me = this;
      me.marcheOptions = response.data.data.list.map((item) => ({
        value: item.marca,
        text: item.marca,
      }));
    },
    loadDataMarcaArticoloError(error) {
      console.log(error);
    },
    loadDataImballoArticolo() {
      let me = this;
      UtilityMixin.methods.loadDataResources(me.pathResourceImballoArticolo, {}, me.loadDataImballoArticoloSuccess, me.loadDataImballoArticoloError);
    },
    loadDataImballoArticoloSuccess(response) {
      let me = this;
      // console.log("RISPOSTA IMBALLO", response);
      me.imballoOptions = response.data.data.list.map((item) => ({
        value: item.descrizioneImballo,
        text: item.descrizioneImballo,
      }));
    },
    loadDataImballoArticoloError(error) {
      console.log(error);
    },
    loadDataStrutture() {
      let me = this;
      UtilityMixin.methods.loadDataResources(me.pathResourceStrutture, null, me.loadDataStruttureSuccess, me.loadDataStruttureError);
    },
    loadDataStruttureSuccess(response) {
      let me = this;
      me.strutturaOptions = response.data.data.map((item) => ({
        value: item.codiceStruttura,
        text: item.denominazione,
      }));
    },
    loadDataStruttureError(response) {
      console.log(response);
    },

    onDeleteArticoloMagazzino(item) {
      let me = this;
      me.$bvModal
        .msgBoxConfirm("Sei sicuro di eliminare questo articolo?", {
          title: "Eliminazione Articolo",
          buttonSize: "sm",
          okTitle: "SI",
          cancelTitle: "NO",
          okVariant: "danger",
          cancelVariant: "secondary",
          hideHeaderClose: true,
          footerClass: "p-2",
          centered: true,
        })
        .then((value) => {
          if (value) {
            me.deleteArticoloMagazzino(item.id);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteArticoloMagazzino(id) {
      let me = this;
      UtilityMixin.methods.deleteResource(me.pathResourceMagazzinoArticolo + "/logicdelete/" + id, null, me.deleteArticoloMagazzinoSuccess, me.deleteArticoloMagazzinoError);
    },
    deleteArticoloMagazzinoSuccess(response) {
      let me = this;
      me.$emit("articoloMagazzinoDelete", response);
      me.$bvToast.toast("Eliminazione avvenuta con successo", {
        title: "Successo",
        variant: "success",
        solid: true,
      });
    },
    deleteArticoloMagazzinoError(response) {
      let me = this;
      me.$emit("articoloMagazzinoDelete", response);
      me.$bvToast.toast("Errore durante l'eliminazione", {
        title: "Errore",
        variant: "danger",
        solid: true,
      });
    },

    onClickSearchCodiceAic() {
      let me = this;
      me.$refs.mdlCodiceAicList.show();
    },
    onUpdate(data) {
      let me = this;
      console.log("Dati ricevuti dal componente figlio:", data);
      me.jsonData.nomeArticolo = data.nomeArticolo;
      me.jsonData.codiceAic = data.codiceAic;
      me.jsonData.descrizioneArticolo = data.descrizioneArticolo;
      me.jsonData.codiceBarre = data.codiceAic;
      console.log("jsonData aggiornato:", me.jsonData);
      me.$bvToast.toast("Farmaco selezionato correttamente", {
        title: "Successo",
        variant: "success",
        solid: true,
      });
    },
    onClickNuovaUM() {
      let me = this;
      me.showModalUM = true;
      me.$nextTick(() => {
        me.$refs.cmpConfigurazioniMagazzinoArticoliUmModalEdit.show(
          {
            id: null,
            codiceAzienda: null,
            descrizioneMultiplo: null,
            multiplo: 0,
            codiceMoltiplicatore: null,
            umBaseId: null,
          },
          false
        );
      });
    },
    onClickNuovaCategoria() {
      let me = this;
      me.showModalCategoria = true;
      me.$nextTick(() => {
        me.$refs.cmpConfigurazioniMagazzinoArticoliCategoriaModalEdit.show(
          {
            id: null,
            codiceAzienda: null,
            categoria: null,
            note: null,
          },
          false
        );
      });
    },
    onClickNuovaMarca() {
      let me = this;
      me.showModalMarca = true;
      me.$nextTick(() => {
        me.$refs.cmpConfigurazioniMagazzinoArticoliMarcaModalEdit.show({}, false);
      });
    },
    // onClickNuovaMultiplo() {
    //   let me = this;
    //   me.showModalMultiplo = true;
    //   me.$nextTick(() => {
    //     me.$refs.cmpConfigurazioniMagazzinoArticoliMultiploModalEdit.show({}, false);
    //   });
    // },
    onClickNuovaImballo() {
      let me = this;
      me.showModalImballo = true;
      me.$nextTick(() => {
        me.$refs.cmpConfigurazioniMagazzinoArticoliImballoModalEdit.show({}, false);
      });
    },

    onSaveUmArticolo() {
      let me = this;
      me.showModalUM = false;
      me.loadDataUmArticolo();
    },
    onSaveCategoriaArticolo() {
      let me = this;
      me.showModalCategoria = false;
      me.loadDataCategoriaArticolo();
    },
    onSaveMarcaArticolo() {
      let me = this;
      me.showModalMarca = false;
      me.loadDataMarcaArticolo();
    },
    onSaveMultiploArticolo() {
      let me = this;
      me.showModalMultiplo = false;
      me.loadDataMultiploArticolo();
    },
    onSaveImballoArticolo() {
      let me = this;
      me.showModalImballo = false;
      me.loadDataImballoArticolo();
    },
  },
};
</script>

<style></style>
